export default __webpack_public_path__ + "static/media/transfacil_galery_11.aea8456b.jpg";